// composables/useDevicePlatform.ts

export type DevicePlatform = 'ios' | 'android' | 'other';

const IOS_STORE_URL = 'https://apps.apple.com/be/app/trustup-pro/id6450792756';
const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.worksite.app&pcampaignid=web_share';

/**
 * Détecte la plateforme du device (iOS / Android / autre) via le user agent
 * et expose l'URL du store correspondant.
 *
 * Fallback : tout ce qui n'est pas iOS pointe vers le Play Store.
 */
export const useDevicePlatform = () => {
    const platform = computed<DevicePlatform>(() => {
        // SPA (ssr: false) → navigator dispo côté client ; garde `typeof` pour la robustesse.
        if (typeof navigator === 'undefined') return 'other';

        const ua = navigator.userAgent || '';

        if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
        if (/android/i.test(ua)) return 'android';

        return 'other';
    });

    // Fallback Play Store : tout ce qui n'est pas iOS → Play Store
    const storeUrl = computed(() => (platform.value === 'ios' ? IOS_STORE_URL : ANDROID_STORE_URL));

    // Type strict pour le tracking PostHog : other → android
    const trackingPlatform = computed<'ios' | 'android'>(() => (platform.value === 'ios' ? 'ios' : 'android'));

    return { platform, storeUrl, trackingPlatform };
};
